import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";
import { acionarAll } from "../../API/acionarAll"; // Renomeando a importação para evitar conflito

const GroupLightComponent = () => {

  const [expanded, setExpanded] = useState({
    legenda: false,
  });

  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo04: React.createRef(),
    grupo05: React.createRef(),
    grupo06: React.createRef(),
    grupo07: React.createRef(),
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo11: React.createRef(),
    grupo12: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo15: React.createRef(),
    grupo16: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
    grupo19: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo04: false,
    grupo05: false,
    grupo06: false,
    grupo07: false,
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo11: false,
    grupo12: false,
    grupo13: false,
    grupo14: false,
    grupo15: false,
    grupo16: false,
    grupo17: false,
    grupo18: false,
    grupo19: false,
    grupo20: false,
    grupo21: false,
  });

  const [loading, setLoading] = useState(true);
  const [acionarAllText, setAcionarAllText] = useState("Ligar");
  const [isBlocked, setIsBlocked] = useState(false); // Estado para bloquear a atualização temporária

  useEffect(() => {
    const fetchData = () => {
      // Só busca dados se não estiver bloqueado
      if (isBlocked) return;

      getLuzesStatusFlex35()
        .then(() => {
          console.log("Feedback de status das luzes:", statusDasLuzesFlex35); // Log do feedback recebido
          updateLightGroup();
          setLoading(false);
        })
        .catch(error => {
          console.error("Erro ao buscar status das luzes:", error);
          setLoading(false); // Para garantir que saia do carregamento mesmo em caso de erro
        });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 3000);

    return () => clearInterval(intervalId);
  }, [isBlocked]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setExpanded({
        legenda: false,
      });
    }, 30000); 

    return () => clearInterval(intervalId);
  }, [expanded]);

  const toggleExpand = (section) => {
    setExpanded((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const updateLightGroup = () => {
    const updatedImageStates = {
      grupo01: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo02: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo03: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo04: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo05: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo06: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo07: statusDasLuzesFlex35.includes("1G10") && !statusDasLuzesFlex35.includes("1G00"),
      grupo08: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo09: statusDasLuzesFlex35.includes("1I10") && !statusDasLuzesFlex35.includes("1I00"),
      grupo10: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo11: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo12: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
      grupo13: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo14: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo15: statusDasLuzesFlex35.includes("1O10") && !statusDasLuzesFlex35.includes("1O00"),
      grupo16: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo17: statusDasLuzesFlex35.includes("1Q10") && !statusDasLuzesFlex35.includes("1Q00"),
      grupo18: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo19: statusDasLuzesFlex35.includes("1S10") && !statusDasLuzesFlex35.includes("1S00"),
      grupo20: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
      grupo21: statusDasLuzesFlex35.includes("1U10") && !statusDasLuzesFlex35.includes("1U00"),
    };

    setImageStates(updatedImageStates);

    // Verifica se todas as luzes estão ligadas para definir o texto do botão
    const todasLuzesLigadas = Object.values(updatedImageStates).every(state => state === true);
    setAcionarAllText(todasLuzesLigadas ? "Desligar" : "Ligar");
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  const handleAcionarAll = async () => {
      const action = Object.values(imageStates).some(state => !state);
      const page = 1;
    
      try {
        const response = await acionarAll(action, page);
        console.log("Resposta do servidor:", response);
    
        // Atualize imediatamente o estado local
        setImageStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = action;
          });
          return newState;
        });
    
        setAcionarAllText(action ? "Desligar" : "Ligar");
    
        // Bloqueia o uso de fetchData no useEffect por 10 segundos
        setIsBlocked(true);
        setTimeout(() => {
          setIsBlocked(false); // Desbloqueia após 10 segundos
        }, 20000);
      } catch (error) {
        console.error("Erro ao acionar todas as luzes:", error);
      }
    };
    

  if (loading) {
    return <div>Carregando...</div>;
  }
  return (
    <>
      <div className="group" id="campoGroup-pagina1">
        {/* Grupo 01 */}
        
          <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes Entrada"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={5.2}
          y={88.1}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes Entrada"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={7.1}
          y={72}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes Entrada"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={9.6}
          y={51.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes Entrada"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={11.6}
          y={36.2}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes Entrada"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={15}
          y={11.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />
        
        {/* Grupo 02 */}

        <LightGroup 
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Jardim Entrada"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={19}
          y={24.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup 
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Jardim Entrada"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={17.2}
          y={35.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup 
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Jardim Entrada"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={16.1}
          y={48}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup 
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Jardim Entrada"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={14.1}
          y={62.8}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup 
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Jardim Entrada"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={24}
          y={28.9}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 03 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Floreira Externa"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={26.1}
          y={35.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Floreira Externa"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={27.4}
          y={54.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Floreira Externa"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={24.7}
          y={61}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Floreira Externa"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={20}
          y={61.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 04 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo04}
          groupId="grupo04"
          descricao="Arandelas Muros"
          imageUrl={imageStates.grupo04 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={26.4}
          y={20}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo04}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 05 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo05}
          groupId="grupo05"
          descricao="Varanda Gourmet"
          imageUrl={imageStates.grupo05 ? Ligado : Desligado}
          onCommand="1E10"
          offCommand="1E00"
          x={34}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo05}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo05}
          groupId="grupo05"
          descricao="Varanda Gourmet"
          imageUrl={imageStates.grupo05 ? Ligado : Desligado}
          onCommand="1E10"
          offCommand="1E00"
          x={40.25}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo05}
          onToggleLightGroup={handleToggleLightGroup}
        />
        
        {/* Grupo 06 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo06}
          groupId="grupo06"
          descricao="Varanda Coberta"
          imageUrl={imageStates.grupo06 ? Ligado : Desligado}
          onCommand="1F10"
          offCommand="1F00"
          x={51}
          y={55.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo06}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 07 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo07}
          groupId="grupo07"
          descricao="Galeria de Acesso"
          imageUrl={imageStates.grupo07 ? Ligado : Desligado}
          onCommand="1G10"
          offCommand="1G00"
          x={34.9}
          y={38.8}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo07}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 08 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo08}
          groupId="grupo08"
          descricao="Led Externo + Guarita"
          imageUrl={imageStates.grupo08 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={26.7}
          y={29.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo08}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 09 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo09}
          groupId="grupo09"
          descricao="Quadra Poliesportiva"
          imageUrl={imageStates.grupo09 ? Ligado : Desligado}
          onCommand="1I10"
          offCommand="1I00"
          x={60.4}
          y={20.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo09}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo09}
          groupId="grupo09"
          descricao="Quadra Poliesportiva"
          imageUrl={imageStates.grupo09 ? Ligado : Desligado}
          onCommand="1I10"
          offCommand="1I00"
          x={59.6}
          y={10.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo09}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 10 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo10}
          groupId="grupo10"
          descricao="Piscina Térreo"
          imageUrl={imageStates.grupo10 ? Ligado : Desligado}
          onCommand="1J10"
          offCommand="1J00"
          x={67.8}
          y={54.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo10}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 11 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Postes Internos Térreo"
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={62.6}
          y={29.4}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Postes Internos Térreo"
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={55.2}
          y={26.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Postes Internos Térreo"
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={58.15}
          y={44.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Postes Internos Térreo"
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={59.4}
          y={62.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 12 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo12}
          groupId="grupo12"
          descricao="Floreira Playground"
          imageUrl={imageStates.grupo12 ? Ligado : Desligado}
          onCommand="1L10"
          offCommand="1L00"
          x={51.15}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo12}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 13 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo13}
          groupId="grupo13"
          descricao="Arandelas Playground"
          imageUrl={imageStates.grupo13 ? Ligado : Desligado}
          onCommand="1M10"
          offCommand="1M00"
          x={46.7}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo13}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo13}
          groupId="grupo13"
          descricao="Arandelas Playground"
          imageUrl={imageStates.grupo13 ? Ligado : Desligado}
          onCommand="1M10"
          offCommand="1M00"
          x={55}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo13}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 14 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo14}
          groupId="grupo14"
          descricao="Floreira Escada Interna"
          imageUrl={imageStates.grupo14 ? Ligado : Desligado}
          onCommand="1N10"
          offCommand="1N00"
          x={65}
          y={29.3}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo14}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 15 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo15}
          groupId="grupo15"
          descricao="Arandelas Piscina Térreo"
          imageUrl={imageStates.grupo15 ? Ligado : Desligado}
          onCommand="1O10"
          offCommand="1O00"
          x={72.5}
          y={70.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo15}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo15}
          groupId="grupo15"
          descricao="Arandelas Piscina Térreo"
          imageUrl={imageStates.grupo15 ? Ligado : Desligado}
          onCommand="1O10"
          offCommand="1O00"
          x={66.6}
          y={70.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo15}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 16 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo16}
          groupId="grupo16"
          descricao="Floreira Pergolado Térreo"
          imageUrl={imageStates.grupo16 ? Ligado : Desligado}
          onCommand="1P10"
          offCommand="1P00"
          x={58.8}
          y={71.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo16}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 17 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo17}
          groupId="grupo17"
          descricao="Postes Garden Gourmet"
          imageUrl={imageStates.grupo17 ? Ligado : Desligado}
          onCommand="1Q10"
          offCommand="1Q00"
          x={71.7}
          y={29.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo17}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo17}
          groupId="grupo17"
          descricao="Postes Garden Gourmet"
          imageUrl={imageStates.grupo17 ? Ligado : Desligado}
          onCommand="1Q10"
          offCommand="1Q00"
          x={80.6}
          y={80.5}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo17}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 18 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo18}
          groupId="grupo18"
          descricao="Arandelas Garden Gourmet"
          imageUrl={imageStates.grupo18 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={77.4}
          y={64.1}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo18}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 19 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo19}
          groupId="grupo19"
          descricao="Floreira Garden Gourmet"
          imageUrl={imageStates.grupo19 ? Ligado : Desligado}
          onCommand="1S10"
          offCommand="1S00"
          x={75.3}
          y={50.6}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo19}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 20 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo20}
          groupId="grupo20"
          descricao="Arandelas Pergolado Térreo"
          imageUrl={imageStates.grupo20 ? Ligado : Desligado}
          onCommand="1T10"
          offCommand="1T00"
          x={72.75}
          y={38.7}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo20}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 21 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo21}
          groupId="grupo21"
          descricao="Floreira Pergolado Térreo"
          imageUrl={imageStates.grupo21 ? Ligado : Desligado}
          onCommand="1U10"
          offCommand="1U00"
          x={71.45}
          y={45.4}
          width={1.5}
          height={3.2}
          imageState={imageStates.grupo21}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Legenda de acionamentos */}
        <div className="campo-clickable-element">
          <div className={`Topico-Menubar${expanded.legenda ? '-expanded' : ''}`}>
            <p
              className={`topicoParagrafoMenuBar${expanded.legenda ? '-expanded' : ''}`}
              onClick={() => toggleExpand('legenda')}
            >
              <b>Acionamentos</b>
            </p>
            {expanded.legenda && (
              <div className="legenda">
                <button className={`bntAcionarAll${acionarAllText === 'Desligar' ? '-ativo' : ''}`} onClick={() => {handleAcionarAll()}}>
                  {acionarAllText} luzes
                </button>
                {[
                  { id: "grupo01", descricao: "Postes Entrada", index: 1 },
                  { id: "grupo02", descricao: "Espetos Jardim", index: 2 },
                  { id: "grupo03", descricao: "Floreira Externa", index: 3 },
                  { id: "grupo04", descricao: "Arandelas Muros", index: 4 },
                  { id: "grupo05", descricao: "Varanda Gourmet", index: 5 },
                  { id: "grupo06", descricao: "Varanda Coberta", index: 6 },
                  { id: "grupo07", descricao: "Galeria de Acesso", index: 7 },
                  { id: "grupo08", descricao: "Led Externo", index: 8 },
                  { id: "grupo09", descricao: "Quadra Poliesportiva", index: 9 },
                  { id: "grupo10", descricao: "Piscina Térreo", index: 10 },
                  { id: "grupo11", descricao: "Postes Internos Térreo", index: 11 },
                  { id: "grupo12", descricao: "Espetos da Floreira", index: 12 },
                  { id: "grupo13", descricao: "Arandelas Playground", index: 13 },
                  { id: "grupo14", descricao: "Floreira Escada Interna", index: 14 },
                  { id: "grupo15", descricao: "Arandelas Piscina Térreo", index: 15 },
                  { id: "grupo16", descricao: "Floreira Pergolado Térreo", index: 16 },
                  { id: "grupo17", descricao: "Postes Garden Gourmet", index: 17 },
                  { id: "grupo18", descricao: "Espetos Garden Gourmet", index: 18 },
                  { id: "grupo19", descricao: "Arandelas Gourmet", index: 19 },
                  { id: "grupo20", descricao: "Espetos Gourmet", index: 20 },
                  { id: "grupo21", descricao: "Piscina Gourmet", index: 21 },
                ].map((item) => (
                  <div
                    key={item.id}
                    id="clickable-element"
                    className="clickable-element"
                    onClick={() => {
                      const newImageState = !imageStates[item.id];
                      handleToggleLightGroup(item.id, newImageState);
                      groupRefs.current[item.id].current.sendCommand(
                        groupRefs.current[item.id].current.props.descricao,
                        newImageState
                          ? groupRefs.current[item.id].current.props.onCommand
                          : groupRefs.current[item.id].current.props.offCommand
                      );
                    }}
                  >
                    <p
                      className={`NumberTextBar${imageStates[item.id] ? "Highlighted" : ""}`}
                    >
                      {item.index}
                    </p>
                    <p className="textBar">{item.descricao}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);